module.exports = __webpack_public_path__ + "img/2024big23.faab09dd.png";